import { OrderStatusAmbarEnum } from "../../../../models/common/Enums";

const dolu = (_deger: string | undefined | null): boolean =>
    _deger !== undefined && _deger !== null && _deger.trim() !== '';

/**
 * Sipariş ekranındaki tarih alanları değiştiğinde Sipariş Durumunun ne olması
 * gerektiğini söyler. Doldurma ve silme simetriktir:
 *
 *   teslim tarihi dolu                    -> Teslim Edildi
 *   teslim boş, yükleme tarihi dolu       -> Yüklendi
 *   ikisi de boş                          -> Oluşturuldu
 *
 * Eskiden durum yalnız alan DOLDURULUNCA değişiyordu; alan silinince eski durum
 * olduğu gibi kalıyordu. Mobil uygulama sipariş durumunu gösterdiği için, web'de
 * teslim tarihi silinen bir yük mobilde "teslim edildi" görünmeye devam ediyordu.
 *
 * İptal edilmiş sipariş bu kuralın dışındadır: iptal bilgisi tarihlerden
 * türetilemez, kullanıcının kararıdır ve korunur.
 */
export const hedefSiparisDurumu = (
    _loadDate: string | undefined,
    _deliveryDate: string | undefined,
    _mevcutDurum?: OrderStatusAmbarEnum | undefined
): OrderStatusAmbarEnum | undefined => {
    if (_mevcutDurum === OrderStatusAmbarEnum.IPTAL_EDILDI)
        return undefined;

    if (dolu(_deliveryDate))
        return OrderStatusAmbarEnum.TESLIM_EDILDI;

    if (dolu(_loadDate))
        return OrderStatusAmbarEnum.YUKLENDI;

    return OrderStatusAmbarEnum.OLUSTURULDU;
}
